import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TrustBar from "./sections/TrustBar";
import Hero from "./sections/Hero";
import Selection from "./sections/Selection";
import Sampler from "./sections/Sampler";
import Sustainability from "./sections/Sustainability";
import Legacy from "./sections/Legacy";
import SustainabilityHighlights from "./sections/SustainabilityHighlights";
import TinnedReadyToEat from "./sections/TinnedReadyToEat";
import Testimonials from "./sections/Testimonials";
import Taste from "./sections/Taste";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TrustBar />
      <Hero />
      <Selection />
      <Sampler />
      <Sustainability />
      <Legacy />
      <SustainabilityHighlights />
      <TinnedReadyToEat />
      <Testimonials />
      <Taste />
      <Footer />
    </div>;
}